module.exports = __webpack_public_path__ + "img/ts.3d23bf38.png";